module.exports = __webpack_public_path__ + "assets/img/menu_img_bg_left.53098e1b.png";